import React, { useState, useEffect } from 'react';
import {
    Row, Col, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText,
    Button
} from 'reactstrap';
import { addFee, getAccount } from '../../API';
import { validateString, store, getInputDate, addMinutesToDateTime } from '../../Helper';

function FeeAdd(props) {
    const [fee, setFee] = useState({ accountID: Number(props.match.params.accountId), divisionID: 1 });
    const [account, setAccount] = useState(null);
    const [isLoadingAccount, setIsLoadingAccount] = useState(true);
    const [divisions, setDivisions] = useState([]);
    const [isLoadingDivisions, setIsLoadingDivisions] = useState(true);

    useEffect(() => {
        fetchDivisions();
        fetchAccount();
    }, []);

    const fetchDivisions = async () => {
        setIsLoadingDivisions(true);

        setDivisions(store.divisions);

        setIsLoadingDivisions(false);
    }

    const fetchAccount = async () => {
        setIsLoadingAccount(true);

        setAccount(await getAccount(fee.accountID));

        setIsLoadingAccount(false);
    }

    const updateFee = e => {
        let value = e.target.value;
        switch (e.target.type) {
            case "number":
                value = e.target.valueAsNumber;
                break;
            case "date":
                value = new Date(e.target.value + 'T23:59:59.999');
                break;
        }

        setFee({
            ...fee,
            [e.target.name]: value
        });
    }

    const blurCurrency = e => {
        e.target.value = e.target.valueAsNumber.toFixed(2);
    }

    const save = async () => {
        if (await addFee(fee))
            props.history.goBack();
    };

    const cancel = () => {
        console.log('Canceling...');
        props.history.goBack();
    };

    let feeJSX = null;
    if (isLoadingAccount) {
        feeJSX = (<div>Loading...</div>);
    } else if (fee) {
        feeJSX = (
            <div className="item-editables">
                <Row xs={1} md={2} lg={3} xl={4}>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-users"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input type="select" name="divisionID" value={fee.divisionID} onChange={updateFee}>
                                    {divisions.map(d => (<option value={d.id} key={d.id}>{d.name}</option>))}
                                </Input>
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-industry"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Facility" name="facility" value={fee.facility || ''} onChange={updateFee} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-hashtag"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="EPA ID/Permit Number" name="identifier" value={fee.identifier || ''} onChange={updateFee} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-file-alt"></i></InputGroupText>
                                </InputGroupAddon>
                                <textarea className="form-control" placeholder="Description" name="feeDescription" value={fee.feeDescription || ''} onChange={updateFee} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="far fa-calendar"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input type="number" min="0" step="1" className="form-control" placeholder="Fiscal Year" name="fiscalYear" value={fee.fiscalYear || ''} onChange={updateFee} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="fas fa-dollar-sign"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input type="number" placeholder="Amount" name="feeAmount" value={fee.feeAmount} onChange={updateFee} onBlur={blurCurrency}/>
                            </InputGroup>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><i className="far fa-calendar-alt"></i></InputGroupText>
                                </InputGroupAddon>
                                <Input type="date" placeholder="Due Date" name="dueDate" value={getInputDate(fee.dueDate) || ''} onChange={updateFee} />
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
                <Row xs={1} md={2} lg={3} xl={4}>
                    <Col className="col" md={{ span: 6 }} lg={{ span: 4, offset: 4 }} xl={{ span: 3, offset: 6 }}>
                        <Button className="btn-block btn-icon" color="danr-red" onClick={cancel}><i className="fas fa-ban"></i><span>Cancel</span></Button>
                    </Col>
                    <Col className="col" md={{ span: 6 }} lg={{ span: 4 }} xl={{ span: 3 }}>
                        <Button className="btn-block btn-icon" color="danr-green" onClick={save}><i className="fas fa-save"></i><span>Save</span></Button>
                    </Col>
                </Row>
            </div>
        );
    }

    return (
        <div>
            <Row className="title-row">
                <Col>
                    <h1>New {account?.name} Fee</h1>
                </Col>
            </Row>
            <Row className="edit-row">
                <Col>
                    {feeJSX}
                </Col>
            </Row>
        </div>
    );
}

export default FeeAdd;